<template>
  <div class='animated fadeIn'>
    <b-row class='justify-content-md-center'>
      <b-col cols='12' lg='10'>
        <b-card class='shadow-sm bg-white rounded' border-variant='light'>
          <div>
            <el-button type='success' icon='el-icon-back' circle @click='goBack'></el-button>
          </div>
        </b-card>
        <b-card class='shadow-sm bg-white rounded' border-variant='light' header-bg-variant='secondary'>
          <b-list-group flush>
            <b-list-group-item>
              <div class='d-flex'>
                <div class='ml-auto p-2 align-middle'>
                  <b-button v-if='routine.key' class='submit-btn' variant='danger' v-b-modal.modal-center>更新</b-button>
                  <b-button v-else class='submit-btn' variant='danger' v-b-modal.modal-center>登録</b-button>
                  <b-modal v-if='routine.key' id='modal-center'
                          ref='modal'
                          title='Routine'
                          @ok='storeData'
                          centered
                          header-bg-variant='danger'
                          body-text-variant='danger'
                          ok-variant='danger'
                          size='sm'
                          class='px100-btn'
                        >
                    <p class='my-4'>Routine を更新します</p>
                    <p class='my-4'>よろしいですか?</p>
                  </b-modal>
                  <b-modal v-else id='modal-center'
                          ref='modal'
                          title='Routine'
                          @ok='storeData'
                          centered
                          header-bg-variant='danger'
                          body-text-variant='danger'
                          ok-variant='danger'
                          size='sm'
                          class='px100-btn'
                        >
                    <p class='my-4'>Routine を登録します</p>
                    <p class='my-4'>よろしいですか?</p>
                  </b-modal>
                </div>
              </div>
            </b-list-group-item>
            <b-list-group-item>
              <b-card-body>
                <b-row>
                  <b-col sm='3'><label for='input-none'>{{getTitle('title')}}:</label></b-col>
                  <b-col sm='9'><el-input size='medium' type='text' v-model='routine.title'></el-input></b-col>
                </b-row>
                <b-row>
                  <b-col sm='3'><label for='input-none'>{{getTitle('subTitle')}}:</label></b-col>
                  <b-col sm='9'><el-input size='medium' type='text' v-model='routine.subTitle'></el-input></b-col>
                </b-row>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('category')}}:</label></b-col>
                  <b-col sm='8'>
                    <b-form-group>
                      <b-form-radio-group id='radios1' v-model='selected' :options='options' name='category'></b-form-radio-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm='3'><label for='input-none'>{{getTitle('mediaLink')}}:</label></b-col>
                  <b-col sm='5'><el-input size='medium' type='text' v-model='routine.mediaLink'></el-input></b-col>
                  <b-col sm='4'>
                    <b-embed v-if=routine.mediaLink type='iframe'
                            aspect='16by9'
                            :src=youtube(routine.mediaLink)
                            allowfullscreen
                    ></b-embed>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-list-group-item>

            <b-list-group-item v-if="user && user.role != 'user'">
              <b-card-body>
                <b-row>
                  <b-col sm='4'><label for='input-none'>所属サービス:</label></b-col>
                  <b-col sm='2'></b-col>
                </b-row>
                <b-row>
                  <b-col sm='2'></b-col>
                  <b-col sm='10'>
                   <b-table
                      :items='services'
                      :fields='sFields'
                      :current-page='sCurrentPage'
                      :per-page='sPerPage'>
                      <div slot='icon' class='avatar' slot-scope='item'>
                        <b-img v-if='item.value' :src='item.value' width='32' height='32'></b-img>
                        <!-- <b-img v-else src='../admin.png' width='32' height='32' class='img-avatar'></b-img> -->
                      </div>
                      <div slot='name' slot-scope='item'>
                        <p>{{ item.value }}</p>
                      </div>
                      <div slot='key' slot-scope='item'>
                        <b-form-checkbox :id='item.value' v-model='routine.services[item.value]'></b-form-checkbox>
                      </div>
                    </b-table>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-list-group-item>

            <b-list-group-item>
              <b-card-body>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('updatedAt')}}:</label></b-col>
                  <b-col>{{ routine.updatedAt * 1000 | moment }}</b-col>
                </b-row>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('createdAt')}}:</label></b-col>
                  <b-col>{{ routine.createdAt * 1000 | moment }}</b-col>
                </b-row>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('owner')}}:</label></b-col>
                  <b-col>
                    <b-img v-if='getUserIcon(routine)' :src='getUserIcon(routine)' width='32' height='32' class='img-avatar'></b-img>
                    <!-- <b-img v-else src='../admin.png' width='32' height='32' class='img-avatar'></b-img> -->
                  </b-col>
                </b-row>
              </b-card-body>
            </b-list-group-item>
          </b-list-group>
        </b-card>
        <b-modal ref='errorModal' centered title='Error' class='text-danger' :ok-only='true' ok-variant=danger header-bg-variant=danger>
          <p class='my-4'>{{errorMessage}}</p>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  data: () => {
    return {
      sCurrentPage: 1,
      sPerPage: 30,
      sFields: {
        icon: {
          label: '',
          class: 'text-center'
        },
        name: {
          label: '名称',
          class: 'text-center'
        },
        key: {
          label: '',
          class: 'text-center'
        }
      },
      selected: 'None',
      options: [
        { text: '[ _ ]', value: 'None' },
        { text: '[心]', value: 'Mental' },
        { text: '[技]', value: 'Skill' },
        { text: '[体]', value: 'Health' },
        { text: '[生]', value: 'Living' }
      ],
      fields: {
        icon: {
          label: '',
          class: 'text-center'
        },
        name: {
          label: '名称',
          class: 'text-center'
        },
        key: {
          label: '',
          class: 'text-center'
        }
      },
      currentPage: 1,
      perPage: 10,
      myCroppa: {},
      errorMessage: '',
      file: null,
      uploadedImage: null,
      titles: {
        'owner': '作成',
        'title': '名称',
        'subTitle': '説明',
        'category': 'Category',
        'groups': 'Groups',
        'mediaLink': 'YouTube（ID）',
        'updatedAt': '更新日時',
        'createdAt': '作成日時'
      },
      routine: null,
      unwatch: null
    }
  },
  beforeDestroy () {
    if (this.unwatch) {
      this.unwatch()
    }
  },
  created () {
    this.unwatch = this.$store.watch(state => this.$store.getters['routine/routines'], value => {
      this.init()
    })
    this.init()
  },
  methods: {
    init () {
      const index = this.routines.findIndex(routine => routine.key === this.parameter)
      if (index !== -1) {
        this.routine = JSON.parse(JSON.stringify(this.routines[index]))
        this.selected = this.routine.category
      } else {
        this.routine = {
          'key': null,
          'owner': this.user.key,
          'title': '',
          'subTitle': '',
          'mediaLink': '',
          'groups': {},
          'category': '',
          'services': this.user.services,
          'createdAt': parseInt(new Date().getTime() / 1000),
          'updatedAt': parseInt(new Date().getTime() / 1000)
        }
      }
    },
    youtube (id) {
      return 'https://www.youtube.com/embed/' + id
    },
    showModal () {
      this.$refs.errorModal.show()
    },
    hideModal () {
      this.$refs.errorModal.hide()
    },
    goBack () {
      this.$router.go(-1)
    },
    getTitle (item) {
      return this.titles[item]
    },
    getUserIcon (routine) {
      const index = this.users.findIndex(user => user.key === routine.owner)
      if (index !== -1) {
        return this.users[index].icon
      }
      return null
    },
    writeroutine () {
      var vm = this
      const payload = {
        'owner': this.routine.owner,
        'title': this.routine.title,
        'subTitle': this.routine.subTitle,
        'mediaLink': this.routine.mediaLink,
        'groups': this.routine.groups,
        'category': this.routine.category,
        'services': this.routine.services,
        'createdAt': this.routine.createdAt,
        'updatedAt': parseInt(new Date().getTime() / 1000)
      }
      const db = firebase.firestore()
      const settings = { timestampsInSnapshots: true }
      db.settings(settings)
      const batch = db.batch()
      var refroutine = null
      if (this.routine.key) {
        refroutine = db.collection('routines').doc(this.routine.key)
      } else {
        refroutine = db.collection('routines').doc()
      }
      batch.set(refroutine, payload)
      batch.commit().then(function () {
        vm.offLoading()
        vm.$router.go(-1)
      })
    },
    storeData () {
      var vm = this
      vm.onLoading()
      this.routine.category = this.selected
      vm.writeroutine()
    }
  },
  computed: {
    ...mapGetters({
      routines: 'routine/routines',
      routineGroups: 'routineGroup/routineGroups',
      routineRefs: 'routineRef/routineRefs',
      services: 'service/services',
      groups: 'group/groups',
      users: 'user/users',
      user: 'authUser/user',
      parameter: 'dispatch/routine'
    })
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY/MM/DD HH:mm')
    },
    momentShort: function (date) {
      return moment(date).format('YYYY/MM/DD')
    },
    momentMMDD: function (date) {
      return moment(date).format('MM/DD')
    }
  }
}
</script>

<style>
.textTitle {
  white-space: normal;
}
.img {
  max-width: 100%;
  height: auto;
}
.row {
  padding-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Routine.vue